<div #outComponent class="out">
  <video controls #videoUploaded playsinline defaultMuted class="fit" [style.width]="video_w" [style.height]="video_h" [style.left]="video_l" [style.top]="video_t">
    <source [src]="sanitized_url" type="video/webm" />
    <source [src]="sanitized_url" type="video/mp4">
  </video>
</div>
